import { Controller } from "stimulus"

export default class extends Controller {
  static classes = ["loading"]

  toggle(event) {
    const dialog = event.currentTarget.commandForElement
    dialog.querySelector("input[name*=target_id]").value = event.currentTarget.dataset.feedbackTargetId
  }

  showLoadingState({ currentTarget }) {
    currentTarget.classList.add(...this.loadingClasses)
  }

  async complete({ target, currentTarget, detail }) {
    target.reset()
    currentTarget.close()
    currentTarget.classList.remove(...this.loadingClasses)
    this.element.insertAdjacentHTML("beforeend", await detail.response.text())
  }

  get loadingClasses() {
    return this.loadingClass.split(" ")
  }
}
